import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes } from "react-router-dom";
import { DialogProvider, ToastProvider } from "../providers";
import { GlobalRoutes } from "./global-routes";
import { PrivateRoutes } from "./privateRoutes";
import { PublicRoutes } from "./publicRoutes";
import { SelectBusinessRoutes } from "./selectBusinessRoutes";

const Router = () => {
  const accessToken = useSelector((state: any) => state.auth.token);
  const business = useSelector((state: any) => state.business);

  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <ToastProvider>
          <DialogProvider>
            <Routes>
              {!accessToken && PublicRoutes}
              {accessToken && !business.activeBusiness && SelectBusinessRoutes}
              {accessToken && business.activeBusiness && PrivateRoutes}
              {GlobalRoutes}
            </Routes>
          </DialogProvider>
        </ToastProvider>
      </LocalizationProvider>
    </BrowserRouter>
  );
};

export { Router };
